import type { PageTour } from '../types';

export const tasksTour: PageTour = {
  id: 'tasks',
  label: 'Tasks Tour',
  steps: [
    {
      target: '[data-tour="tasks-header"]',
      title: 'Task Management',
      content: 'Welcome to the task board. Here you can create, assign, and track tasks across all your projects.',
    },
    {
      target: '[data-tour="tasks-create"]',
      title: 'Create Tasks',
      content: 'Click here to create a new task. Assign it to a team member, set priorities, and add due dates.',
    },
    {
      target: '[data-tour="tasks-filters"]',
      title: 'Filters & Search',
      content: 'Filter tasks by project, assignee, priority, or status to focus on what matters most.',
    },
    {
      target: '[data-tour="tasks-tabs"]',
      title: 'Task Views',
      content: 'Switch between different views — board, list, or backlog — to manage tasks your way.',
    },
    {
      target: '[data-tour="tasks-board"]',
      title: 'Task Board',
      content: 'Drag and drop tasks between columns to update their status. Each column represents a workflow stage.',
    },
  ],
};
